import { EMPTY_GUID, getKeyByValue } from "@utils/helpers";
import { ConnectorSource } from "@utils/optionsSets/OptionSets";
import { getImgConnector } from "features/journey-map/swimlanes/customer-feedbacks/CustomerFeedbackCard";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { GenericButton, GenericDropdown, IconDispatcher, Input, Label } from "shared/ui-basics";
import { CustomBreadCrumb } from "shared/ui-basics/ui-components/CustomBreadCrumb";
import { upsertConnector } from "../reducer/ConnectorAction";
import * as Style from "./Styles";

export const newConnector = (source) => {
    return {
        id: EMPTY_GUID,
        source: source,
        retrieveDataFrequency: "100000004",
        enableConnection: true
    }
};

export const dataFrequency = [{ id: '100000000', value: "Single Time" },
{ id: '100000001', value: "Daily" },
{ id: '100000002', value: "Weekly" },
{ id: '100000003', value: "Monthly" },
{ id: '100000004', value: "Yearly" }]

const IntegrationForm = () => {
    const { t } = useTranslation();
    const { search } = useLocation();
    const history = useHistory();
    const { id, source } = search.getIntegrationProps();
    const connector = useSelector((state) => state.settings.connector)?.find((connector) => connector.id === id) || newConnector(source);
    const [currentConnector, setCurrentConnector] = useState(connector);
    const [validated, setValidated] = useState(true);
    const [error, setError] = useState("");
    const [startUpdate, setStartUpdate] = useState(false)
    const connectorName = getKeyByValue(ConnectorSource, source);
    const name = t(connectorName?.toUpperCase());
    const isGlobalError = (error !== "" && error !== "TOKEN_NOT_VALID" && !validated);
    const isTokenNotValid = (error === "TOKEN_NOT_VALID" && !validated);
    const handleChange = (e, type) => {
        let { name, value } = e.target;
        setCurrentConnector({ ...currentConnector, [type ?? name]: value });
    };
    const validation = () => {
        return currentConnector?.name !== "" && currentConnector?.token !== "" && currentConnector?.host;
    }
    const goBack = () => {
        history.push(`/integration`);
    }
    const onFailed = (error) => {
        setStartUpdate(false);
        setError(error?.response?.data)
        setValidated(false);

    }
    const submit = (event) => {
        event.preventDefault();
        if (validation()) {
            setStartUpdate(true);
            upsertConnector({ connector: { ...currentConnector, enableConnection: true }, onSuccess: goBack, onFailed })
        }
        else {
            setValidated(false);
        }
    }

    return <Style.ContainerPage >
        <div className="mb-2">
            <CustomBreadCrumb paths={[t("ASPX_207"), t("INTEGRATION"), currentConnector?.id === EMPTY_GUID ? t("NEW_CONNECTOR") : currentConnector?.name]} backFunction={goBack} />
        </div>
        <Style.WrapperPage>
            <Style.WrapperHeader className="py-2">
                <Style.ImgWrapper className="me-3" src={getImgConnector(parseInt(source))} />
                <Label size={20}>{name}</Label>
            </Style.WrapperHeader>
            <Style.WrapperForm id={currentConnector?.id} className="" onSubmit={submit}>
                <div className="d-flex flex-column gap-4 p-4">
                    <div className="">
                        <Label className="pb-2">{t("NAME")}</Label>
                        <Input variant="default"
                            invalid={!currentConnector?.name && !validated}
                            name="name"
                            type="text"
                            value={currentConnector?.name}
                            onChange={handleChange}
                            placeholder={t("ENTER_NAME")} />
                    </div>
                    <div className="">
                        <Label className="pb-2">{t("TOKEN")}</Label>
                        <Input variant="default"
                            invalid={(!currentConnector?.token && !validated) || isTokenNotValid}
                            name="token"
                            type="text"
                            value={currentConnector?.token || ""}
                            onChange={handleChange}
                            placeholder={t("ENTER_TITLE")} />
                        {isTokenNotValid && <Label size={12} color="#dc3545">{t("Token not valid")}</Label>}

                    </div>
                    <div className="">
                        <Label className="pb-2">{t("HOST")}</Label>
                        <Input variant="default"
                            invalid={!currentConnector?.host && !validated}
                            name="host"
                            type="text"
                            value={currentConnector?.host || ""}
                            onChange={handleChange}
                            placeholder={t("ENTER_TITLE")} />
                    </div>
                    <div className="">
                        <Label className="pb-2">{t("RETRIEVE_DATA_FREQUENCY")}</Label>
                        <GenericDropdown icon border options={dataFrequency} value={currentConnector.retrieveDataFrequency ?? '100000000'} onClick={(e) => { handleChange(e, "retrieveDataFrequency") }} />
                    </div>
                    {isGlobalError && <Style.WrapperError>
                        <div>{IconDispatcher("triangle-exclamation", "", { style: "solid", color: "#dc3545" })}</div>
                        <Label size={12} color="#dc3545">{t("ERROR")}: {error}</Label>
                    </Style.WrapperError>}

                </div>
                <Style.WrapperFooter className=" p-4 pt-0">
                    <GenericButton variant="light-link" onClick={goBack} className="me-3">
                        {t('ASPX_86')}
                    </GenericButton>
                    <GenericButton disabled={startUpdate} loading={startUpdate} variant="primary" type="submit" >
                        {t('ENABLE')}
                    </GenericButton>
                </Style.WrapperFooter>
            </Style.WrapperForm>
        </Style.WrapperPage>
    </Style.ContainerPage>
}



export default IntegrationForm;